import { render, staticRenderFns } from "./ResistCorp.vue?vue&type=template&id=5e127666&"
import script from "./ResistCorp.vue?vue&type=script&lang=js&"
export * from "./ResistCorp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports